import * as React from 'react'
import { default as MuiSlider, SliderProps } from '@mui/material/Slider'

export const Slider = (props: SliderProps) => {
  return <MuiSlider {...props} />
}

export default Slider
